import {style} from "@vanilla-extract/css";

export const overlayStyles = {
  backdrop: style({
    backgroundColor: "rgba(100, 100, 100, 0.9)",
  }),
};
